import {Box} from '@mui/material'

const TabContent = ({children, value, index, ...other}) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && <Box>{children}</Box>}
        </Box>
    )
}

export default TabContent
